import Loader from '.';

 const LoadingPage = () => {
   return (
     <div className="container mx-auto flex h-[100svh] items-center justify-center">
       <Loader />
     </div>
   );
 };

 export default LoadingPage;